import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';
import { ComponentRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export class EuiDialogConfig {
    id: string;
    e2eAttr = 'eui-dialog';
    typeClass: ('info' | 'success' | 'warning' | 'danger' | 'question');
    title: string;
    message: string;
    hasFooter = true;
    headerComponent: {
        component: any;
        config: any;
    };
    bodyComponent: {
        component: any;
        config: any;
    };
    footerComponent: {
        component: any;
        config: any;
    };
    dismissButton = {
        label: 'eui.CANCEL',
        icon: null,
        disabled: false,
    };
    acceptButton = {
        label: 'eui.OK',
        icon: null,
        disabled: false,
    };
    draggable = false;
    disableClose = false;
    width = '33vw';
    height = 'auto';
    isHandleCloseOnDismiss = false;
    isHandleCloseOnClose = false;
    isHandleCloseOnAccept = false;
    isHandleCloseOnClickOutside = false;
    hasNoBodyPadding = false;

    onClick: (value: boolean, componentInstances: EuiDialogInjectedComponentInstances) => any;
    onDismiss: (dialogRef: MatDialogRef<any>, componentInstances: EuiDialogInjectedComponentInstances) => any;
    onAccept: (dialogRef: MatDialogRef<any>, componentInstances: EuiDialogInjectedComponentInstances) => any;
    onClose: (dialogRef: MatDialogRef<any>, componentInstances: EuiDialogInjectedComponentInstances) => any;
    onClickOutside: (dialogRef: MatDialogRef<any>, componentInstances: EuiDialogInjectedComponentInstances) => any;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export class EuiDialogInjectedComponentInstances {
    headerComponent: { portalHost: DomPortalOutlet, portal: ComponentPortal<any>, portalComponentInstance: ComponentRef<any> };
    bodyComponent: { portalHost: DomPortalOutlet, portal: ComponentPortal<any>, portalComponentInstance: ComponentRef<any> };
    footerComponent: { portalHost: DomPortalOutlet, portal: ComponentPortal<any>, portalComponentInstance: ComponentRef<any> };

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
